import VueRouter from 'vue-router'
import viewsCollection, {constantRouterMap as cRouterMan, asyncRouterMap as aRouteMap} from '../views/index';
import Store from '../store/index';
import {
  get,
} from 'lodash';
import {
  platform
} from 'src/common/Fn';
import config from 'src/config/config';
import BuildRoute from 'src/class/BuildRoute';
import Mta from 'src/service/Mta';
import Vue from 'vue';

Vue.use(VueRouter)

let buildRouter = new BuildRoute(cRouterMan,viewsCollection,Store, true);
// 实例化路由
const routes = buildRouter.toRouter();

const Router = new VueRouter({
  routes,
  base: config.base,
  mode: platform.isApp() ? 'hash' : 'history',
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
});

Router.afterEach((to, from) => {
  // 添加来源
  buildRouter.afterEach(to, from);

  // 添加来源
  if (to.name === 'user_login'
    && from
    && ['user_login', 'user_register', 'user_reset_password', 'user_setting'].join(',').indexOf(from.name) === -1) {
    let fromUrl = '';
    if (from.name && from.fullPath) {
      // 从上一个路由来登录
      fromUrl = from.fullPath;
    } else if (!from.name && from.fullPath === '/') { // 上一个页面是不存在的
      //排除掉登录回来的场景
      if (get(Router.match(location.pathname), 'name') != 'user_login') {
        fromUrl = location.href.replace(location.protocol + '//' + location.host, '');
      }
    }

    if (fromUrl) {
      try {
        global.sessionStorage.setItem('__from__', fromUrl);
      } catch (e) {
      }
    }
  }

  if ( !platform.isApp() ) {
    Vue.nextTick(() => {
      // 处理微信当中，页面分享的标题
      let needShare = get(to, 'meta.needShare', true);
      if (needShare && platform.isWeChat()) {
        let headerInfo = get(Store, 'state.header.titleInfo');
      }

      // 埋点统计
      if (config.mta.url) {
        Mta.command('pgv');
      }
    });
  }
});

// 不要删除本行代码，以防止跳转时的bug
global.__router = Router;

// 异步路由
const asyncRouterMap = (new BuildRoute(aRouteMap,viewsCollection,Store, true)).toRouter();

export default Router;

export {
  routes as constantRouterMap,
  asyncRouterMap
}



// WEBPACK FOOTER //
// ./src/router/index.js